module.exports = __webpack_public_path__ + "9ccea4ebf3e1a5611c3ed2d1f28076e8.png";